import { HeaderService } from '@my-backoffice/app/pages/main/shared/components/header/shared/service/header.service';
import { FreshChatService } from '@my-backoffice/app/pages/main/shared/services/fresh-chat.service';
import { IUser } from '@my-backoffice/app/pages/user/shared/models/interfaces/user.interface';
import { AUTHENTICATION_SERVICE } from '@my-backoffice/app/shared/auth/authentication.token';
import { EBrokerType } from '@my-backoffice/app/shared/models/enums/broker-type.enum';
import { IAccountMenuItem } from '@my-backoffice/app/shared/models/interfaces/account-menu-item.interface';
import { QimaIconService } from '@my-backoffice/app/shared/services/exported-services/qima-icon/qima-icon.service';
import { QimaShadowService } from '@my-backoffice/app/shared/services/exported-services/qima-shadow/qima-shadow.service';
import { QimaTooltipService } from '@my-backoffice/app/shared/services/exported-services/qima-tooltip/qima-tooltip.service';
import { AppUserSettingService } from '@my-backoffice/app/shared/services/user-services/app-user-setting/app-user-setting.service';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { QimaOptionalType, QimaShadowDirectiveModule, QimaAutoTooltipDirectiveModule, QimaIconModule } from '@qima/ngx-qima';

@Component({
  selector: 'app-account-menu',
  standalone: true,
  templateUrl: './account-menu.component.html',
  styleUrls: ['./account-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [QimaShadowDirectiveModule, QimaAutoTooltipDirectiveModule, QimaIconModule, TranslateModule],
})
export class AccountMenuComponent implements OnInit {
  public currentUser!: IUser;
  public isBroker = false;
  public parentCompanyName: QimaOptionalType<string>;
  public profileMenuItems: IAccountMenuItem[] = [];

  private readonly _authenticationService = inject(AUTHENTICATION_SERVICE);

  public constructor(
    private readonly _headerService: HeaderService,
    private readonly _router: Router,
    private readonly _freshChatService: FreshChatService,
    private readonly _appUserSettingService: AppUserSettingService,
    public readonly shadowService: QimaShadowService,
    public readonly qimaTooltip: QimaTooltipService,
    public readonly qimaIcon: QimaIconService
  ) {}

  public ngOnInit(): void {
    this.currentUser = this._authenticationService.getCurrentUser();
    this.isBroker = this.currentUser?.company?.brokerType === EBrokerType.BROKER;
    this.parentCompanyName = this.currentUser.company?.parentCompanyName;
    this._initData();
  }

  public onAccountMenuItemClick(item: IAccountMenuItem): void {
    this._closeMenu();
    void this._router.navigateByUrl(item.path);
  }

  public logout(): void {
    this._freshChatService.clearFreshChat();
    this._authenticationService.logout();
  }

  private _closeMenu(): void {
    this._headerService.updateIsProfileMenuVisible(false);
  }

  private _initData(): void {
    if (this._appUserSettingService.getIsQimaProduce()) {
      this.profileMenuItems = [this.profileMenuItems[0]];
    } else if (this._appUserSettingService.getIsLifeScience()) {
      this.profileMenuItems = [];
    }
  }
}
